/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import { useMemo } from 'react'
import Page from '../../components/Page'
import RegistrationList from './RegistrationsList'
import JoinTeamButton from 'src/features/teamFinder/components/JoinTeamButton'
import { enablePlayerTeamFinder } from '@sportninja/common/utils/utils'

const Registrations = () => {
  const actions = useMemo(() => {
    // SN-8453 — Team Finder is Canlan-only.
    return enablePlayerTeamFinder ? [<JoinTeamButton key='find-a-team' />] : []
  }, [])

  const pages = useMemo(
    () => [
      {
        to: `${ROUTES.REGISTRATIONS.ROOT}/my`,
        component: <RegistrationList />,
        actions: actions,
      },
    ],
    [actions]
  )

  const BASE_ROUTE = ROUTES.REGISTRATIONS.ROOT

  return (
    // @ts-ignore
    <Page
      baseRoute={BASE_ROUTE}
      // @ts-ignore
      pages={pages}
      baseTitle='Registrations'
      title='My Registrations'
      isOrgsPage={true}
      hideBreadcrumbs={true}
      displayMobileActions={false}
    />
  )
}

export default Registrations
